import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from "react";
export var useFileUploaderState = function useFileUploaderState(onUploadSuccess, onUploadError) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(undefined),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    errorMessage = _React$useState4[0],
    setErrorMessage = _React$useState4[1];
  var clearErrorMessage = function clearErrorMessage() {
    setErrorMessage(undefined);
  };
  var handleUploadSuccess = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            clearErrorMessage();
            _context.next = 4;
            return onUploadSuccess(file);
          case 4:
            setLoading(false);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleUploadSuccess(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleUploadError = function handleUploadError(error) {
    setErrorMessage(error);
    onUploadError(error);
  };
  return {
    loading: loading,
    errorMessage: errorMessage,
    handleUploadSuccess: handleUploadSuccess,
    handleUploadError: handleUploadError
  };
};